import { Cookies } from 'react-cookie';

import { CompleteEncounterFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PutCompleteEncounterProps {
  encId: number;
  enc: CompleteEncounterFormValues;
  objectSlug: string;
}

export const putCompleteEncounter = async ({ encId, enc, objectSlug }: PutCompleteEncounterProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const formData = new FormData();

  Object.entries(enc).forEach(([key, value]) => {
    if (key !== 'photos' && key !== 'connected_vuls' && value !== null && value !== undefined) {
      formData.append(key, String(value));
    }
  });

  if (enc.photos && enc.photos.length > 0) {
    enc.photos.forEach((file: File) => {
      formData.append('photos', file);
    });
  }
  if (enc.connected_vuls && enc.connected_vuls.length > 0) {
    enc.connected_vuls.forEach((vulId: number) => {
      formData.append('connected_vuls', String(vulId));
    });
  }

  const data = await axiosInterceptor.put(`/encounters/${objectSlug}/${encId}/fix-encounter/`, formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
